export enum SendAsOptions {
    CommaSeparated = 'CommaSeparated',
    SemicolonSeparated = 'SemicolonSeparated',
}
